import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { isProduction } from "./serviceConfig";

export const CONNECTION_STRING = "InstrumentationKey=ba51b6ee-af17-49a3-9c8c-bca71a0ca416;IngestionEndpoint=https://uksouth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://uksouth.livediagnostics.monitor.azure.com/;ApplicationId=b1f1bb28-e76d-4a7c-9374-321fe106d23d";

let appInsights = null;

export const initializeApplicationInsights = () => {
    if (!isProduction || appInsights) return;

    appInsights = new ApplicationInsights({
        config: {
            connectionString: CONNECTION_STRING,
            enableAutoRouteTracking: true,
            autoTrackPageVisitTime: true,
            enableCorsCorrelation: true,
        },
    });

    appInsights.loadAppInsights();
};

export const getAppInsights = () => appInsights;
